
export default function VideoSection() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block mb-4 px-4 md:px-6 py-2 bg-teal-50 border border-teal-200 rounded-full">
            <span className="text-teal-600 font-semibold tracking-wider text-xs md:text-sm uppercase">
              영상 자료
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6">
            관련 <span className="text-teal-600">영상 자료</span>
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed font-medium">
            로보에셋그리드의 기술력과 수도미터기 관련 주요 보도 영상
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-10 md:space-y-16">
          {/* KBS 뉴스 영상 */}
          <div>
            <div className="text-center mb-6 md:mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900">
                문제 관련 뉴스 보도
              </h3>
              <p className="text-xs md:text-base text-gray-600 mt-2">
                수도미터기 납 성분 문제와 규제 부재 현황 관련 보도
              </p>
            </div>

            <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border border-gray-200">
              <div className="relative aspect-video w-full">
                <iframe
                  src="https://www.youtube.com/embed/DrR08OJZk1Q?si=YlHqOIk9VKVoUU1Q"
                  title="수도미터기 납 성분 관련 뉴스 보도"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>

              {/* Video Info */}
              <div className="p-4 md:p-8 bg-gray-50">
                <div className="flex items-start gap-4 md:gap-6">
                  <div className="flex-shrink-0 hidden sm:block">
                    <div className="w-12 md:w-16 h-12 md:h-16 bg-red-100 rounded-xl flex items-center justify-center">
                      <i className="ri-alert-line text-2xl md:text-3xl text-red-600"></i>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">
                      주요 보도 내용
                    </h4>
                    <ul className="space-y-2 text-xs md:text-base text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-red-600 mt-0.5 flex-shrink-0"></i>
                        <span>가정용 수도계량기에서 기준치 이상의 납 성분 검출</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-red-600 mt-0.5 flex-shrink-0"></i>
                        <span>국내 수도미터기 납 성분 규제 기준 부재</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-red-600 mt-0.5 flex-shrink-0"></i>
                        <span>미국은 0.25% 이하로 제한, 유럽은 납 성분 사용 금지</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 추가 뉴스 영상 */}
          <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border border-gray-200">
            <div className="relative aspect-video w-full">
              <iframe
                src="https://www.youtube.com/embed/CLKhnB94sKA?si=cxcClYKX6wzhbbPR"
                title="수도미터기 관련 추가 뉴스 보도"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>

            {/* Video Info */}
            <div className="p-4 md:p-8 bg-gradient-to-r from-gray-50 to-slate-50">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="flex-shrink-0 hidden sm:block">
                  <div className="w-12 md:w-16 h-12 md:h-16 bg-orange-100 rounded-xl flex items-center justify-center">
                    <i className="ri-newspaper-line text-2xl md:text-3xl text-orange-600"></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">
                    관련 뉴스 보도
                  </h4>
                  <p className="text-xs md:text-base text-gray-600 leading-relaxed">
                    수도미터기 납 성분 문제와 관련된 추가 보도 영상입니다.
                    국민 건강과 안전을 위한 규제 마련의 필요성을 확인하세요.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 회사 홍보영상 */}
          <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border border-gray-200">
            <div className="relative aspect-video w-full">
              <iframe
                src="https://www.youtube.com/embed/ey5On3dFI5Y?si=tFSd6K8E3_tl-IoE"
                title="로보에셋그리드 테스트공장 및 연구센터 홍보영상"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>

            {/* Video Info */}
            <div className="p-4 md:p-8 bg-gradient-to-r from-teal-50 to-cyan-50">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="flex-shrink-0 hidden sm:block">
                  <div className="w-12 md:w-16 h-12 md:h-16 bg-teal-100 rounded-xl flex items-center justify-center">
                    <i className="ri-building-2-line text-2xl md:text-3xl text-teal-600"></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">
                    로보에셋그리드 테스트공장 및 연구센터 홍보영상
                  </h4>
                  <p className="text-xs md:text-base text-gray-600 leading-relaxed">
                    로보에셋그리드의 최첨단 테스트공장과 연구센터를 소개합니다.
                    광학 센싱 기술 기반의 스마트 수도미터기 개발 및 품질 검증 시설을 확인하세요.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-lg border border-gray-200">
              <div className="w-10 md:w-12 h-10 md:h-12 bg-red-100 rounded-xl flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-error-warning-line text-xl md:text-2xl text-red-600"></i>
              </div>
              <h5 className="font-bold text-sm md:text-base text-gray-900 mb-1 md:mb-2">
                국내 규제 부재
              </h5>
              <p className="text-gray-600 text-xs md:text-sm">
                수도미터기 납 성분에 대한 명확한 규제 기준이 없는 실정
              </p>
            </div>

            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-lg border border-gray-200">
              <div className="w-10 md:w-12 h-10 md:h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-global-line text-xl md:text-2xl text-teal-600"></i>
              </div>
              <h5 className="font-bold text-sm md:text-base text-gray-900 mb-1 md:mb-2">
                해외 규제 현황
              </h5>
              <p className="text-gray-600 text-xs md:text-sm">
                미국 0.25% 이하, 유럽은 납 성분 사용 전면 금지
              </p>
            </div>

            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-lg border border-gray-200">
              <div className="w-10 md:w-12 h-10 md:h-12 bg-green-100 rounded-xl flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-shield-check-line text-xl md:text-2xl text-green-600"></i>
              </div>
              <h5 className="font-bold text-sm md:text-base text-gray-900 mb-1 md:mb-2">
                당사 솔루션
              </h5>
              <p className="text-gray-600 text-xs md:text-sm">
                스테인리스 재질로 납 성분 문제 완전 해결
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
